const buildUrlWithParams = (url: string, params: Record<string, string | undefined>) => {
  const urlObj = new URL(url);
  Object.entries(params).forEach(([key, value]) => {
    value && urlObj.searchParams.set(key, value);
  });
  return urlObj.toString();
};

const createSafeFileUrl = (file: File) => {
  try {
    return URL.createObjectURL(file);
  } catch {
    return undefined;
  }
};

export const urlUtils = {
  buildUrlWithParams,
  createSafeFileUrl,
};
